import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { WaterBody } from 'anchor-shared/lib/model/entity/waterBody';
import { WaterBodyDAO } from '../../../../../../../core/services/dao/waterBodyDAO';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { AppLocation } from '../../../../../../../core/models/interface/geo';
import { MooringLocationDAO } from '../../../../../../../core/services/dao/mooringLocationDAO';
import { UserDAO } from '../../../../../../../core/services/dao/userDAO';
import { ContainsSubscriptions } from '../../../../../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../../../../../core/pure-functions/rx-helper';
import { getAddressObject } from 'anchor-shared/lib/service/pure-functions/places-input-helpers';

@Component({
  selector: 'app-boat-location-form',
  templateUrl: './boat-location.component.html',
  styleUrls: ['./boat-location.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class BoatLocationFormComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  subs: Subscription[] = [];
  @Input() model: Vessel;
  @Input() selectedWaterBodies: any[];
  @Input() disabled: boolean;
  @Output() setWaterBodiesChanged = new EventEmitter();
  @Output() setMooringLocationChanged = new EventEmitter();
  waterBodies: WaterBody[];
  location: AppLocation;
  placesInputInvalid: boolean;
  isAdmin: boolean;
  parkingLocation: AppLocation;
  parkingPlacesInputInvalid: boolean;
  locationModel: Partial<Vessel>;

  constructor(
    private waterBodyDao: WaterBodyDAO,
    private mooringLocationDao: MooringLocationDAO,
    private userDAO: UserDAO,
  ) {
    const waterBodiesSub = this.waterBodyDao.get().subscribe((wb) => {
      this.waterBodies = wb;
    });
    this.subs.push(waterBodiesSub);
    this.location = {
      position: {
        lat: 27.964157,
        lng: -82.452606,
      },
      addressComponents: [],
      formattedAddress: '',
      vicinity: '',
      markerLatitude: 0,
      markerLongitude: 0,
      zoom: 8,
    };
    this.parkingLocation = {
      position: {
        lat: 27.964157,
        lng: -82.452606,
      },
      addressComponents: [],
      formattedAddress: '',
      vicinity: '',
      markerLatitude: 0,
      markerLongitude: 0,
      zoom: 8,
    };
  }

  ngOnInit() {
    const mooringLocationSub = this.mooringLocationDao
      .getByVesselId(this.model.id)
      .subscribe((mooringLocation) => {
        this.model.mooringLocation = mooringLocation;
        if (this.model.mooringLocation.lat && this.model.mooringLocation.long) {
          this.location.markerLatitude = this.model.mooringLocation.lat;
          this.location.markerLongitude = this.model.mooringLocation.long;
          this.location.mapLatitude = this.model.mooringLocation.lat;
          this.location.mapLongitude = this.model.mooringLocation.long;
          this.location.zoom = 15;
        }
        if (
          this.model.mooringLocation.parkingLat &&
          this.model.mooringLocation.parkingLong
        ) {
          this.parkingLocation.markerLatitude =
            this.model.mooringLocation.parkingLat;
          this.parkingLocation.markerLongitude =
            this.model.mooringLocation.parkingLong;
          this.parkingLocation.mapLatitude =
            this.model.mooringLocation.parkingLat;
          this.parkingLocation.mapLongitude =
            this.model.mooringLocation.parkingLong;
          this.parkingLocation.zoom = 15;
        }
        this.setModel();
      });
    this.subs.push(mooringLocationSub);
    this.isAdmin = this.userDAO.currentUserIsAdmin();
  }

  emitWaterBodiesChanged() {
    this.setWaterBodiesChanged.emit(this.model.mooringLocation);
  }

  autocompleteMooring(location: AppLocation): void {
    this.placesInputInvalid = false;
    this.location = location;
    this.model.mooringLocation.address = this.location.formattedAddress;
    this.model.mooringLocation.lat = this.location.position.lat;
    this.model.mooringLocation.long = this.location.position.lng;
    this.model.mooringLocation.mooringAddressComponents = getAddressObject(
      location.addressComponents,
    );
    this.setModel();
  }

  autocompleteParking(location: AppLocation): void {
    this.parkingPlacesInputInvalid = false;
    this.parkingLocation = location;
    this.model.mooringLocation.parkingAddress =
      this.parkingLocation.formattedAddress;
    this.model.mooringLocation.parkingLat = this.parkingLocation.position.lat;
    this.model.mooringLocation.parkingLong = this.parkingLocation.position.lng;
    this.model.mooringLocation.parkingAddressComponents = getAddressObject(
      location.addressComponents,
    );
    this.setModel();
  }

  setModel() {
    this.locationModel = {
      id: this.model.id,
      parkingNotes: this.model.parkingNotes,
      specialInstructions: this.model.specialInstructions,
      welcomeNote: this.model.welcomeNote,
      mooringLocation: {
        id: this.model.mooringLocation.id,
        parkingAddress: this.model.mooringLocation.parkingAddress,
        parkingLat: this.model.mooringLocation.parkingLat,
        parkingLong: this.model.mooringLocation.parkingLong,
        address: this.model.mooringLocation.address,
        lat: this.model.mooringLocation.lat,
        long: this.model.mooringLocation.long,
        vesselId: this.model.id,
        parkingAddressComponents:
          this.model.mooringLocation.parkingAddressComponents,
        mooringAddressComponents:
          this.model.mooringLocation.mooringAddressComponents,
      },
    };
  }

  placesInputChange(): void {
    this.placesInputInvalid = true;
    this.setMooringLocationChanged.emit();
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }
}
